import { createContext } from "react";

export const DocsPurchasesContext = createContext(null);
